import { Outlet, NavLink } from 'react-router-dom';

export function AppShell() {
  return (
    <div className="app-shell-layout">
      <header className="topbar">
        <NavLink to="/trips" className="brand">
          Camper Diary
        </NavLink>
        <nav>
          <NavLink to="/trips">Viaggi</NavLink>
          <NavLink to="/plans">Pianificazione</NavLink>
          <NavLink to="/pois">POI</NavLink>
          <NavLink to="/livella">Livella</NavLink>
          <NavLink to="/settings">Impostazioni</NavLink>
        </nav>
      </header>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
